import { contactLabel, type Contact } from '~/utils/contact';

type ContactCheckboxListProps<T extends Contact> = {
  contacts: T[];
  selectedContactIds: Set<string>;
  onToggle: (contact: T) => void;
  checkboxIdPrefix: string;
};

export function ContactCheckboxList<T extends Contact>({
  contacts,
  selectedContactIds,
  onToggle,
  checkboxIdPrefix,
}: Readonly<ContactCheckboxListProps<T>>) {
  return (
    <>
      {contacts.map((contact) => {
        const checkboxId = `${checkboxIdPrefix}-${contact.id}`;
        return (
          <li key={contact.id} className="px-1 py-2 flex items-center gap-2">
            <input
              id={checkboxId}
              type="checkbox"
              className="h-4 w-4 cursor-pointer"
              checked={selectedContactIds.has(contact.id)}
              onChange={() => onToggle(contact)}
            />
            <label
              htmlFor={checkboxId}
              className="text-sm w-full min-w-0 truncate cursor-pointer"
            >
              {contactLabel(contact)}
            </label>
          </li>
        );
      })}
    </>
  );
}
